import { notification } from 'antd';
export function validateComparators(data, comparator) {
    if (
      (comparator == '<' || comparator == '<=') &&
      (typeof data.maxValue === 'undefined' || data.maxValue <= 0)
    ) {
      notification.warn({ message: 'Max Value should be greater than 0' });
      return false;
    }
    if (
      (comparator == '>' || comparator == '>=') &&
      (typeof data.minValue === 'undefined' || data.minValue <= 0)
    ) {
      notification.warn({ message: 'Min Value should be greater than 0' });
      return false;
    }
    if (
      comparator == 'BETWEEN' &&
      (typeof data.minValue === 'undefined' || data.minValue < 0)
    ) {
      notification.warn({ message: 'Min Value should be greater than 0 or 0' });
      return false;
    }
    if (
      comparator == 'BETWEEN' &&
      (typeof data.minValue === 'undefined' ||
        typeof data.maxValue === 'undefined' ||
        data.minValue >= data.maxValue)
    ) {
      notification.warn({ message: 'Max Value should be greater than Min Value' });
      return false;
    }
    if (comparator == '=' && (typeof data.maxValue === 'undefined' || data.maxValue <= 0)) {
      notification.warn({ message: 'Value should be greater than 0' });
      return false;
    }
    return true; // All validations passed
}